var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.3 0a3.3 3.3 0 0 1 3.288 3.012A3.3 3.3 0 0 1 15.6 6.3v6a3.3 3.3 0 0 1-3.3 3.3h-6a3.3 3.3 0 0 1-3.288-3.012A3.3 3.3 0 0 1 0 9.3v-6A3.3 3.3 0 0 1 3.3 0zm-3 3h4.47A1.5 1.5 0 0 0 9.3 1.8h-6a1.5 1.5 0 0 0-1.5 1.5v6A1.5 1.5 0 0 0 3 10.77V6.3A3.3 3.3 0 0 1 6.3 3m6 1.8a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5z",
  clipRule: "evenodd"
})));
export default SvgCopyIcon;